import { Card, CardContent } from '@material-ui/core';
import { Column, Columns, Stack } from '@superdispatch/ui';
import { useSubscriptionDetails } from 'shared/modules/subscription/SubscriptionAPI';
import { useFlag } from 'shared/settings/FeatureToggles';
import { SubscriptionPaymentInformation } from '../subscription/SubscriptionPaymentInformation';
import { SubscriptionContactCard } from './SubscriptionContactCard';
import { SubscriptionPlanInformation } from './SubscriptionPlanInformation';

export function SubscriptionDetailsCard() {
  const { data: subscriptionDetails } = useSubscriptionDetails();
  const isSubscriptionContactEnabled = useFlag('ctms_subscription_contact');
  const customer = subscriptionDetails?.customer;
  const shouldShowSubscriptionContact =
    isSubscriptionContactEnabled && !!customer?.payment_method?.card;

  if (!subscriptionDetails?.subscription?.plan) {
    return null;
  }

  return (
    <Columns space="small" collapseBelow="tablet">
      <Column>
        <Stack space="small">
          <SubscriptionPaymentInformation />
          {shouldShowSubscriptionContact && <SubscriptionContactCard />}
        </Stack>
      </Column>
      <Column>
        <Card>
          <CardContent>
            <SubscriptionPlanInformation />
          </CardContent>
        </Card>
      </Column>
    </Columns>
  );
}
